(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1474],{

/***/ 6585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32793);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1048);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98885);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30577);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51705);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];








const styles = {
  entering: {
    transform: 'none'
  },
  entered: {
    transform: 'none'
  }
};

/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/material-ui/react-button/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Zoom = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Zoom(props, ref) {
  const theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      addEndListener,
      appear = true,
      children,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = react_transition_group__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);
  const nodeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(nodeRef, children.ref, ref);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .reflow */ .n)(node); // So the animation always start from the start.

    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
          transform: 'scale(0)',
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Zoom);

/***/ }),

/***/ 56039:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experiences/[slug]",
      function () {
        return __webpack_require__(40505);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* reexport */ useGetExperience; },
  "T": function() { return /* reexport */ useGetExperiences; }
});

// EXTERNAL MODULE: ./src/logic/libs/index.ts
var libs = __webpack_require__(81900);
// EXTERNAL MODULE: ./src/constants/cashing.ts
var cashing = __webpack_require__(29236);
;// CONCATENATED MODULE: ./src/logic/services/experiences/services.ts


var url = "experiences";
var useGetExperiences = (0,libs/* createQuery */.rP)({
    method: "get",
    url: "".concat(url)
}, {
    staleTime: cashing/* long_term_cashing */.d
});
var useGetExperience = (0,libs/* createQuery */.rP)({
    url: "".concat(url, "/unique-name/:slug"),
    method: "get"
});

;// CONCATENATED MODULE: ./src/logic/services/experiences/index.ts




/***/ }),

/***/ 40505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ExperienceDetails": function() { return /* binding */ ExperienceDetails; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/logic/services/experiences/index.ts + 1 modules
var experiences = __webpack_require__(63449);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./src/components/shared/image-box-future.tsx
var image_box_future = __webpack_require__(58718);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./src/theme/typography.ts
var typography = __webpack_require__(43795);
;// CONCATENATED MODULE: ./src/components/experience/experiences-specialities-slider.tsx








var ExperienceSpecialitiesSlider = function(experiencesProps) {
    var ref;
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "div",
        sx: {
            width: "100%",
            "& .swiper": {
                px: {
                    laptop: (0,typography/* pxToRem */.Q)(15),
                    tablet: (0,typography/* pxToRem */.Q)(0)
                },
                pb: {
                    tablet: (0,typography/* pxToRem */.Q)(86),
                    mobile: "50px"
                },
                position: "relative",
                direction: "ltr"
            },
            "& .swiper-wrapper": {
                alignItems: " center"
            },
            "& .swiper-slide.swiper-slide-next div.MuiBox-root": {
                height: "100%"
            },
            "& .swiper-slide.swiper-slide-next  div.MuiBox-root::after, .swiper-slide div.MuiBox-root div.MuiBox-root::after": {
                width: "0%"
            },
            "& .swiper-horizontal>.swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .swiper-pagination-fraction": {
                bottom: {
                    tablet: (0,typography/* pxToRem */.Q)(48),
                    mobile: "24px"
                }
            },
            "& .swiper-slide": (0,_define_property/* default */.Z)({
                display: "flex"
            }, theme.breakpoints.down(768), {
                display: "flex",
                justifyContent: "center"
            }),
            "& .swiper-slide a": {
                display: "none"
            },
            "& .swiper-slide.swiper-slide-next a": {
                display: "flex"
            },
            "& .swiper-pagination-bullet": {
                width: {
                    tablet: (0,typography/* pxToRem */.Q)(12),
                    mobile: "6px"
                },
                height: {
                    tablet: (0,typography/* pxToRem */.Q)(12),
                    mobile: "6px"
                },
                background: theme.palette.grey[30],
                backdropFilter: " blur(5px)",
                mx: (0,typography/* pxToRem */.Q)(6),
                borderRadius: "100%",
                cursor: "pointer"
            },
            "& .swiper-pagination-bullet-active": {
                background: theme.palette.primary.main,
                border: "1px solid ".concat(theme.palette.primary.main),
                width: {
                    tablet: (0,typography/* pxToRem */.Q)(14),
                    mobile: "8px"
                },
                height: {
                    tablet: (0,typography/* pxToRem */.Q)(14),
                    mobile: "8px"
                }
            },
            "& .swiper-pagination": {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            spaceBetween: 46,
            slidesPerView: 3,
            modules: [
                swiper_esm/* Pagination */.tl
            ],
            pagination: {
                clickable: true
            },
            scrollbar: {
                draggable: true
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                }
            },
            children: experiencesProps === null || experiencesProps === void 0 ? void 0 : (ref = experiencesProps.Specialty) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: "section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            component: "div",
                            sx: {
                                background: theme.palette.layout.bgSecondary,
                                boxShadow: theme.customShadows.cardShadow,
                                borderRadius: "25px",
                                position: "relative",
                                cursor: "grab",
                                marginBottom: (0,typography/* pxToRem */.Q)(24)
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                    img: item.cover,
                                    title: item === null || item === void 0 ? void 0 : item.name,
                                    layout: "intrinsic",
                                    objectFit: "cover",
                                    width: "1920px",
                                    height: "1080px",
                                    sx: {
                                        borderRadius: "20px",
                                        overflow: "hidden "
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    component: "div",
                                    sx: {
                                        p: (0,typography/* pxToRem */.Q)(24),
                                        pt: (0,typography/* pxToRem */.Q)(22)
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                            title: item.name,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "h3",
                                                sx: {
                                                    fontSize: {
                                                        tablet: (0,typography/* pxToRem */.Q)(28),
                                                        mobile: "18px"
                                                    },
                                                    color: theme.palette.grey[90],
                                                    mb: (0,typography/* pxToRem */.Q)(24),
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: "1",
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    maxWidth: "100%"
                                                },
                                                children: item.name
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            component: "p",
                                            sx: {
                                                fontSize: {
                                                    tablet: (0,typography/* pxToRem */.Q)(24),
                                                    mobile: "16px"
                                                },
                                                color: theme.palette.grey[50],
                                                height: {
                                                    tablet: (0,typography/* pxToRem */.Q)(144),
                                                    mobile: "96px"
                                                },
                                                mb: (0,typography/* pxToRem */.Q)(32),
                                                display: "-webkit-box",
                                                WebkitLineClamp: "4",
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            },
                                            children: item.description
                                        })
                                    ]
                                })
                            ]
                        }, item.id)
                    }, item.id)
                }, item.id);
            })
        })
    });
};
/* harmony default export */ var experiences_specialities_slider = (ExperienceSpecialitiesSlider);

// EXTERNAL MODULE: ./src/constants/movie-types-enum.ts
var movie_types_enum = __webpack_require__(15432);
// EXTERNAL MODULE: ./src/components/shared/movies-list.tsx + 1 modules
var movies_list = __webpack_require__(23944);
// EXTERNAL MODULE: ./src/components/seo/seo.tsx
var seo = __webpack_require__(89183);
// EXTERNAL MODULE: ./src/logic/hooks/index.ts + 27 modules
var hooks = __webpack_require__(7663);
// EXTERNAL MODULE: ./src/logic/services/index.ts + 21 modules
var services = __webpack_require__(10029);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/pages/experiences/[slug].tsx















var paginationShowing = {
    limit: 4,
    page: 1
};
var __N_SSP = true;
var ExperienceDetails = function(param) {
    var path = param.path;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var query = (0,router.useRouter)().query;
    var ref15 = (0,hooks/* useCity */.hA)(), browserCityId = ref15.cityId;
    var cityId = +query.cityId || browserCityId;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var ref16 = (0,experiences/* useGetExperience */.x)({
        query: {
            slug: query.slug
        },
        params: {
            cityId: cityId
        }
    }), experienceData = ref16.data;
    var ref17 = (0,services/* useGetInfiniteMovies */.$3)({
        params: {
            experienceIds: [
                experienceData === null || experienceData === void 0 ? void 0 : experienceData.experience.id
            ],
            cityId: cityId,
            limit: paginationShowing.limit,
            page: paginationShowing.page,
            type: movie_types_enum/* MovieTypesEnum.SHOW_NOW */.g.SHOW_NOW
        }
    }, {
        enabled: !!experienceData
    }), data = ref17.data, isError = ref17.isError, fetchNextPage = ref17.fetchNextPage, hasNextPage = ref17.hasNextPage, isFetching = ref17.isFetching, isFetchingNextPage = ref17.isFetchingNextPage;
    var movies = (0,react.useMemo)(function() {
        var ref;
        return (data === null || data === void 0 ? void 0 : data.pages) ? data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.flatMap(function(group) {
            return group.data;
        }) : [];
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: (experienceData === null || experienceData === void 0 ? void 0 : (ref = experienceData.experience) === null || ref === void 0 ? void 0 : ref.titleTag) || intl.formatMessage({
                    id: "experience_details"
                }),
                canonical: experienceData === null || experienceData === void 0 ? void 0 : (ref1 = experienceData.experience) === null || ref1 === void 0 ? void 0 : ref1.canonicalURL,
                pagePath: path,
                description: (experienceData === null || experienceData === void 0 ? void 0 : (ref2 = experienceData.experience) === null || ref2 === void 0 ? void 0 : ref2.descriptionTag) || (experienceData === null || experienceData === void 0 ? void 0 : (ref3 = experienceData.experience) === null || ref3 === void 0 ? void 0 : ref3.description),
                image: experienceData === null || experienceData === void 0 ? void 0 : (ref4 = experienceData.experience) === null || ref4 === void 0 ? void 0 : ref4.cover,
                noFollow: experienceData === null || experienceData === void 0 ? void 0 : (ref5 = experienceData.experience) === null || ref5 === void 0 ? void 0 : ref5.hasFollow,
                noIndex: experienceData === null || experienceData === void 0 ? void 0 : (ref6 = experienceData.experience) === null || ref6 === void 0 ? void 0 : ref6.hasIndex
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: "div",
                sx: {
                    flexGrow: 1,
                    mb: (0,typography/* pxToRem */.Q)(122),
                    "& h1,h2,h3,h4,h5": {
                        fontWeight: 700
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "h1",
                        sx: (0,_define_property/* default */.Z)({
                            fontSize: (0,typography/* pxToRem */.Q)(30),
                            color: theme.palette.grey[80],
                            my: (0,typography/* pxToRem */.Q)(52),
                            fontWeight: 700,
                            px: {
                                laptop: (0,typography/* pxToRem */.Q)(128),
                                tablet: (0,typography/* pxToRem */.Q)(60),
                                mobile: "18px"
                            },
                            maxWidth: "1920px",
                            mx: "auto"
                        }, theme.breakpoints.down("tablet"), {
                            mt: "32px",
                            mb: "24px"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "experience_details"
                        })
                    }),
                    !isError && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        component: "div",
                        sx: {},
                        children: [
                            (experienceData === null || experienceData === void 0 ? void 0 : (ref7 = experienceData.experience) === null || ref7 === void 0 ? void 0 : ref7.cover) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: "section",
                                sx: {
                                    position: "relative"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                    img: experienceData === null || experienceData === void 0 ? void 0 : (ref8 = experienceData.experience) === null || ref8 === void 0 ? void 0 : ref8.cover,
                                    title: (experienceData === null || experienceData === void 0 ? void 0 : (ref9 = experienceData.experience) === null || ref9 === void 0 ? void 0 : ref9.coverAlt) || (experienceData === null || experienceData === void 0 ? void 0 : (ref10 = experienceData.experience) === null || ref10 === void 0 ? void 0 : ref10.name),
                                    layout: "intrinsic",
                                    objectFit: "cover",
                                    width: "1920px",
                                    height: "1080px",
                                    sx: {
                                        marginBottom: (0,typography/* pxToRem */.Q)(32)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    maxWidth: "1920px",
                                    mx: "auto"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        component: "section",
                                        sx: {
                                            px: {
                                                laptop: (0,typography/* pxToRem */.Q)(128),
                                                tablet: (0,typography/* pxToRem */.Q)(60),
                                                mobile: "16px"
                                            },
                                            mb: (0,typography/* pxToRem */.Q)(48)
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            component: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    component: "h4",
                                                    sx: {
                                                        fontSize: {
                                                            tablet: (0,typography/* pxToRem */.Q)(24),
                                                            mobile: "16px"
                                                        },
                                                        color: theme.palette.grey[90],
                                                        mb: (0,typography/* pxToRem */.Q)(48)
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "experience_details.about"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body1",
                                                    color: "text.secondary",
                                                    sx: {
                                                        fontSize: {
                                                            tablet: (0,typography/* pxToRem */.Q)(24),
                                                            mobile: "16px"
                                                        },
                                                        color: theme.palette.grey[50],
                                                        maxWidth: "1096px",
                                                        lineHeight: "150%",
                                                        whiteSpace: "pre-wrap"
                                                    },
                                                    children: experienceData === null || experienceData === void 0 ? void 0 : (ref11 = experienceData.experience) === null || ref11 === void 0 ? void 0 : ref11.description
                                                })
                                            ]
                                        })
                                    }),
                                    (experienceData === null || experienceData === void 0 ? void 0 : (ref12 = experienceData.experience) === null || ref12 === void 0 ? void 0 : ref12.specialties.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        component: "section",
                                        sx: {
                                            overflow: "hidden",
                                            px: {
                                                laptop: (0,typography/* pxToRem */.Q)(128 - 15),
                                                tablet: (0,typography/* pxToRem */.Q)(60),
                                                mobile: "16px"
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "h4",
                                                sx: {
                                                    fontSize: {
                                                        tablet: (0,typography/* pxToRem */.Q)(24),
                                                        mobile: "16px"
                                                    },
                                                    color: theme.palette.grey[90],
                                                    mb: (0,typography/* pxToRem */.Q)(32),
                                                    px: {
                                                        laptop: (0,typography/* pxToRem */.Q)(15),
                                                        tablet: 0
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "experience_details.available_experience_specialities"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(experiences_specialities_slider, {
                                                Specialty: experienceData === null || experienceData === void 0 ? void 0 : (ref13 = experienceData.experience) === null || ref13 === void 0 ? void 0 : ref13.specialties
                                            })
                                        ]
                                    }),
                                    movies.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        component: "div",
                                        sx: {
                                            px: {
                                                laptop: (0,typography/* pxToRem */.Q)(128),
                                                tablet: (0,typography/* pxToRem */.Q)(60),
                                                mobile: "16px"
                                            },
                                            mb: (0,typography/* pxToRem */.Q)(500)
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                component: "h4",
                                                sx: {
                                                    fontSize: (0,typography/* pxToRem */.Q)(24),
                                                    color: theme.palette.grey[90],
                                                    mb: {
                                                        tablet: (0,typography/* pxToRem */.Q)(59),
                                                        mobile: "16px"
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "experience_details.movies_showing_in"
                                                    }),
                                                    experienceData === null || experienceData === void 0 ? void 0 : (ref14 = experienceData.experience) === null || ref14 === void 0 ? void 0 : ref14.name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(movies_list/* default */.Z, {
                                                moviesList: movies,
                                                hasMore: hasNextPage,
                                                fetchMovies: fetchNextPage,
                                                isFetching: isFetching,
                                                isFetchingNextPage: isFetchingNextPage,
                                                sx: {
                                                    mt: {
                                                        mobile: "0px"
                                                    }
                                                },
                                                itemListName: "Experiences"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var _slug_ = (ExperienceDetails);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6886,4386,719,6102,9774,2888,179], function() { return __webpack_exec__(56039); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);